var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container cursor-pointer",on:{"click":_vm.redirectToLibrary}},[_c('base-image',{staticClass:"px-2",attrs:{"src":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }